import { createSelector } from '@reduxjs/toolkit';
import { isFreeUser, Role } from 'zl-shared/dist/auth';

import { AppState } from '../helper';

export const selectIsFreeUser = createSelector(
  (state: AppState) => state.user.role,
  (state: AppState) => state.user.subscription.active ?? false,
  (role, active) => isFreeUser(role as Role, { active }),
);

export const selectShouldShowAppOnboarding = createSelector(
  (state: AppState) => state.user.logged,
  (state: AppState) => state.user.isAppOnboarded,
  (state: AppState) => state.modals.appOnboardingModal,
  (logged, isAppOnboarded, modalState) => logged && !isAppOnboarded && !Object.values(modalState).every(Boolean),
);

export const selectCanDownloadMedia = createSelector(
  [
    (state: AppState) => state.user.logged,
    (state: AppState) => state.user.role,
    (state: AppState) => state.user.subscription.active,
    (state: AppState) => state.user.subscription.validUntil,
  ],
  (logged, role, active, validUntil) => {
    if (!logged) {
      return false;
    }
    if (![Role.USER, Role.VIP].includes(role as Role)) {
      return true;
    }
    return active && validUntil && Date.parse(validUntil) > Date.now();
  },
);
